export default {
      id: "ic_arrow_right-usage",
      viewBox: "0 0 30 30",
      url: "/" + "images/icons.3.109.2.svg#ic_arrow_right-usage",
      toString: function () {
        return this.url;
      }
    }